module.exports = __webpack_public_path__ + "img/dach_22.f0b15c55.jpg";